import { render, staticRenderFns } from "./StudentChat.vue?vue&type=template&id=6f7923bc&scoped=true"
import script from "./StudentChat.vue?vue&type=script&lang=js"
export * from "./StudentChat.vue?vue&type=script&lang=js"
import style0 from "./StudentChat.vue?vue&type=style&index=0&id=6f7923bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7923bc",
  null
  
)

export default component.exports